<div class="filters-box">
  <mat-form-field2
    class="d-block"
    [showLabel]="false"
    matTooltip="Filter the below discounts by type."
    matTooltipPosition="above"
    matTooltipClass="text-center"
    i18n-matTooltip
  >
    <mat-select placeholder="Type" i18n-placeholder [formControl]="filters.get('type')">
      <mat-option value="all" i18n>All</mat-option>
      <mat-option value="pct" i18n>Percent</mat-option>
      <mat-option value="flat" i18n>Flat</mat-option>
    </mat-select>
  </mat-form-field2>
  <app-select-search
    class=""
    bindValue="id"
    bindLabel="friendlyName"
    [items]="channels$ | async"
    [ctrl]="filters.get('channels')"
    placeholder="Channels"
    i18n-placeholder
    matTooltip="Filter the below discounts by channel."
    matTooltipPosition="above"
    matTooltipClass="text-center"
    i18n-matTooltip
    *ngIf="showChannelFilter"
  >
  </app-select-search>
  <app-rental-select
    [inline]="true"
    [ctrl]="filters.get('rentals')"
    placeholder="Rentals"
    i18n-placeholder
    matTooltip="Filter the below discounts by rental."
    i18n-matTooltip
    *ngIf="showRentalFilter"
  >
  </app-rental-select>
  <app-cancel-filters
    [isFiltering]="filters | isFiltering"
    [filterControl]="filters"
    [searchCom]="search"
    [ignoreFields]="clearFiltersIgnoreFields"
  ></app-cancel-filters>

  <app-button
    (click)="onRefresh()"
    icon="far fa-sync"
    class="btn btn-secondary-primary"
    [loading]="isRefreshing$ | async"
    matTooltip="Refresh"
    matTooltipPosition="above"
    i18n-matTooltip
  >
  </app-button>

  <div class="flex-fill"></div>

  <app-table-search
    #search
    (search)="onSearch($event)"
    [filterGroup]="filterGroup"
    matTooltip="Search by any values visible in the table below"
    matTooltipPosition="above"
    matTooltipClass="text-center"
    i18n-matTooltip
  ></app-table-search>
  <button
    type="button"
    class="btn btn-secondary-danger"
    (click)="onDeleteSelected()"
    [disabled]="selection.isEmpty() || (1 | isReadonlyRole)"
  >
    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
  </button>

  <button type="button" class="btn btn-secondary-info" (click)="onAdd()" [disabled]="1 | isReadonlyRole">
    <i class="far fa-plus"></i> <ng-container i18n>Add LOS Discount</ng-container>
  </button>
</div>
<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="created" matSortDirection="desc" [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null"
            [checked]="selection.isSelected(element)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="text-truncate" [matTooltip]="element.name" matTooltipPosition="above">{{ element.name }}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Amount</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.type === 'pct' ? element.amount + '%' : (element.amount | number : '.2-2')
          }}<ng-container *ngIf="hasLOS">{{ element.modality === modalities.PerNight ? '(PN)' : '(PS)' }}</ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rentalsView">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Rentals</mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [matTooltip]="element.rentalsView"
          [matTooltipHideDelay]="element.rentalsView?.length"
          matTooltipPosition="above"
          matTooltipClass="tooltip-lg"
        >
          <ng-container *ngIf="element.rentals?.length">{{ element.rentals?.length }}</ng-container>
          <ng-container *ngIf="!element.rentals?.length" i18n>All Rentals</ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="channelsView">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Channels</mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.channelsView" matTooltipPosition="above">
          <ng-container *ngIf="element.channels?.length">{{ element.channels?.length }}</ng-container>
          <ng-container *ngIf="!element.channels?.length" i18n>All Channels</ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startView">
        <mat-header-cell *matHeaderCellDef mat-sort-header="start" i18n>Start</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.startView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="endView">
        <mat-header-cell *matHeaderCellDef mat-sort-header="end" i18n>End</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.endView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="length">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Length</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.length || '' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="guests">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Guests</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.guests || '' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="createdView">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Created</mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.created | epoch" matTooltipPosition="above">
          {{ element.createdView || '' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef i18n> EDIT </mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom left" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button (click)="onEdit(element)" type="button">
                  <i class="fal fa-file-alt"></i><ng-container i18n>View</ng-container>
                </button>
              </li>
              <li>
                <button (click)="onDelete(element)" type="button">
                  <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="clickable" (click)="onEdit(row)"></mat-row>
    </mat-table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
